import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import { RAPID_REWARDS_NUMBER_SCHEMA_FIELD_NAME } from "./RapidRewardsNumberFormField.schema";

/**
 * RapidRewardsNumberFormField facilitates the input of a Rapid rewards number/account number.
 */

export const RapidRewardsNumberFormField = (props) => {
  const {
    componentProps,
    description,
    disabled,
    name = RAPID_REWARDS_NUMBER_SCHEMA_FIELD_NAME,
  } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("RapidRewardsNumberFormField__ARIA"),
        ...componentProps,
      },
      description,
      disabled,
      label: i18n("RapidRewardsNumberFormField__LABEL"),
      name,
    };
  }
};

export const rapidRewardsNumberFormFieldPropTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Text to appear above form control and to the right of the label. */
  description: PropTypes.string,

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

RapidRewardsNumberFormField.propTypes = rapidRewardsNumberFormFieldPropTypes;
